import * as t from './types';
import { Dispatch } from 'redux';
import {bonusService} from "modules/Bonus/services";


export const bonusUserSync = () => async (dispatch: Dispatch) => {
    dispatch({ type: t.FETCH_BONUS_START });

    try {
        const data = await bonusService.fetchBonus();
        let payload = data;
        return dispatch({ type: t.FETCH_BONUS_SUCCESS, payload });
    } catch (error) {
        dispatch({ type: t.FETCH_BONUS_FAILURE, payload: error?.response });
        return  error?.response
    }
};
